<script setup lang="ts">
defineProps<{
  title: string;
  body: string;
}>();
</script>

<template>
  <lxc-information class="!pl-0">
    <template #component>
      <lxc-info-sign>
        <i-lxc-info height="1.5em" width="1.5em" />
      </lxc-info-sign>
    </template>
    <template #body>
      <div class="font-semibold">
        {{ title }}
      </div>
      <div>
        {{ body }}
      </div>
    </template>
  </lxc-information>
</template>
